export default {
  organizationStructure(state) {
    return state?.organizationStructure ?? {}
  },

  organizationTags(state) {
    return state?.organizationStructure?.tags ?? []
  },

  organizationSites(state) {
    return state?.organizationStructure?.sites ?? []
  },

  organizationSiteGroups(state) {
    return state?.organizationStructure?.siteGroups ?? []
  },

  organizationTagGroups(state) {
    return state?.organizationStructure?.tagGroups ?? []
  },

  organizationCountryCodes(state) {
    return state?.organizationCountryCodes ?? []
  },

  organizationCategories(state) {
    return state?.organizationCategories ?? []
  },

  organizationSituationTypes(state) {
    return state?.organizationSituationTypes ?? []
  },
}
